import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const zar = (n) =>
  `R ${Number(n || 0).toLocaleString("en-ZA", { maximumFractionDigits: 0 })}`;

export const fetchVehicles = () =>
  axios.get(`${API}/vehicles`).then((r) => r.data.vehicles);

export const submitPrequalify = (data) =>
  axios.post(`${API}/prequalify`, data).then((r) => r.data);

export const submitApplication = (data) =>
  axios.post(`${API}/applications`, data).then((r) => r.data);

export const submitContact = (data) =>
  axios.post(`${API}/contact`, data).then((r) => r.data);

const TOKEN_KEY = "compcar_admin_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);
const authHeaders = () => ({ headers: { Authorization: `Bearer ${getToken()}` } });

export const adminLogin = (email, password) =>
  axios.post(`${API}/auth/login`, { email, password }).then((r) => r.data);
export const adminMe = () => axios.get(`${API}/auth/me`, authHeaders()).then((r) => r.data);
export const adminStats = () => axios.get(`${API}/admin/stats`, authHeaders()).then((r) => r.data);
export const createVehicle = (data) =>
  axios.post(`${API}/admin/vehicles`, data, authHeaders()).then((r) => r.data);
export const updateVehicle = (id, data) =>
  axios.put(`${API}/admin/vehicles/${id}`, data, authHeaders()).then((r) => r.data);
export const deleteVehicle = (id) =>
  axios.delete(`${API}/admin/vehicles/${id}`, authHeaders()).then((r) => r.data);

export const formatApiErrorDetail = (detail) => {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
};

export const adminLeads = (type) =>
  axios.get(`${API}/admin/leads${type ? `?type=${type}` : ""}`, authHeaders()).then((r) => r.data);
export const updateLeadStatus = (id, status) =>
  axios.patch(`${API}/admin/leads/${id}`, { status }, authHeaders()).then((r) => r.data);
export const adminGetSettings = () =>
  axios.get(`${API}/admin/settings`, authHeaders()).then((r) => r.data);
export const adminSaveSettings = (data) =>
  axios.put(`${API}/admin/settings`, data, authHeaders()).then((r) => r.data);
export const uploadImage = (file) => {
  const form = new FormData();
  form.append("file", file);
  return axios
    .post(`${API}/admin/upload`, form, {
      headers: { Authorization: `Bearer ${getToken()}`, "Content-Type": "multipart/form-data" },
    })
    .then((r) => r.data);
};
export const mediaUrl = (path) =>
  path && path.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${path}` : path;

export const publicUpload = (file) => {
  const form = new FormData();
  form.append("file", file);
  return axios.post(`${API}/upload`, form).then((r) => r.data);
};

export const adminLead = (id) =>
  axios.get(`${API}/admin/leads/${id}`, authHeaders()).then((r) => r.data);

export const adminMediaUrl = (path) =>
  `${process.env.REACT_APP_BACKEND_URL}/api/admin/media/${path}`;

export const downloadQuotation = async (vehicleId, term) => {
  const res = await axios.get(`${API}/admin/quotation/${vehicleId}?term=${term}`, {
    ...authHeaders(),
    responseType: "blob",
  });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = `CompCar-Quotation-${term}m.pdf`;
  a.click();
  URL.revokeObjectURL(url);
};

export const whatsappLink = (message) =>
  `https://wa.me/27614507416?text=${encodeURIComponent(message)}`;

export const adminGenerateAgreement = (leadId) =>
  axios.post(`${API}/admin/leads/${leadId}/agreement`, {}, authHeaders()).then((r) => r.data);
export const adminSendReminder = (leadId) =>
  axios.post(`${API}/admin/leads/${leadId}/reminder`, {}, authHeaders()).then((r) => r.data);
export const getAgreement = (token) =>
  axios.get(`${API}/agreements/${token}`).then((r) => r.data);
export const signAgreement = (token, data) =>
  axios.post(`${API}/agreements/${token}/sign`, data).then((r) => r.data);

export const adminGenerateStatement = (leadId, data) =>
  axios.post(`${API}/admin/leads/${leadId}/statement`, data, authHeaders()).then((r) => r.data);
export const getStatement = (token) =>
  axios.get(`${API}/statements/${token}`).then((r) => r.data);
export const statementPdfUrl = (token) =>
  `${process.env.REACT_APP_BACKEND_URL}/api/statements/${token}/pdf`;

export const adminAddPayment = (leadId, data) =>
  axios.post(`${API}/admin/leads/${leadId}/payments`, data, authHeaders()).then((r) => r.data);
export const adminDeletePayment = (leadId, paymentId) =>
  axios.delete(`${API}/admin/leads/${leadId}/payments/${paymentId}`, authHeaders()).then((r) => r.data);

const PORTAL_KEY = "compcar_portal_token";
export const getPortalToken = () => sessionStorage.getItem(PORTAL_KEY);
export const setPortalToken = (t) => sessionStorage.setItem(PORTAL_KEY, t);
export const clearPortalToken = () => sessionStorage.removeItem(PORTAL_KEY);
const portalHeaders = () => ({ headers: { Authorization: `Bearer ${getPortalToken()}` } });

export const portalLogin = (data) =>
  axios.post(`${API}/portal/login`, data).then((r) => r.data);
export const portalMe = () =>
  axios.get(`${API}/portal/me`, portalHeaders()).then((r) => r.data);
export const portalMediaUrl = (path) =>
  `${process.env.REACT_APP_BACKEND_URL}/api/portal/media/${path}`;

export const downloadCsv = async (path, filename) => {
  const res = await axios.get(`${API}/admin/export/${path}`, { ...authHeaders(), responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
};

export const fetchReviews = () => axios.get(`${API}/reviews`).then((r) => r.data.reviews);
export const adminAddReview = (data) =>
  axios.post(`${API}/admin/reviews`, data, authHeaders()).then((r) => r.data);
export const adminDeleteReview = (id) =>
  axios.delete(`${API}/admin/reviews/${id}`, authHeaders()).then((r) => r.data);

export const submitRental = (data) =>
  axios.post(`${API}/rentals`, data).then((r) => r.data);
export const submitTradeIn = (data) =>
  axios.post(`${API}/trade-in`, data).then((r) => r.data);

export const depositCheckout = (reference, origin_url) =>
  axios.post(`${API}/payments/deposit-checkout`, { reference, origin_url }).then((r) => r.data);
export const paymentStatus = (sessionId) =>
  axios.get(`${API}/payments/status/${sessionId}`).then((r) => r.data);
export const adminSetService = (leadId, data) =>
  axios.put(`${API}/admin/leads/${leadId}/service`, data, authHeaders()).then((r) => r.data);

export const getRentalBooking = (reference) =>
  axios.get(`${API}/rentals/${reference}`).then((r) => r.data);

export const getReceipt = (token) =>
  axios.get(`${API}/receipts/${token}`).then((r) => r.data);
export const receiptPdfUrl = (token) =>
  `${process.env.REACT_APP_BACKEND_URL}/api/receipts/${token}/pdf`;

export const getCertificate = (token) =>
  axios.get(`${API}/certificates/${token}`).then((r) => r.data);
export const certificatePdfUrl = (token) =>
  `${process.env.REACT_APP_BACKEND_URL}/api/certificates/${token}/pdf`;
export const adminIssueCertificate = (leadId) =>
  axios.post(`${API}/admin/leads/${leadId}/certificate`, {}, authHeaders()).then((r) => r.data);

export const instalmentCheckout = (origin_url) =>
  axios.post(`${API}/payments/instalment-checkout`, { origin_url }, portalHeaders()).then((r) => r.data);

export const settlementCheckout = (origin_url) =>
  axios.post(`${API}/payments/settlement-checkout`, { origin_url }, portalHeaders()).then((r) => r.data);

export const fetchRentalAvailability = (slug) =>
  axios.get(`${API}/rentals/availability${slug ? `?vehicle_slug=${slug}` : ""}`).then((r) => r.data.ranges);

export const validateReferral = (code) =>
  axios.get(`${API}/referrals/${encodeURIComponent(code)}`).then((r) => r.data);
export const trackApplication = (data) =>
  axios.post(`${API}/track`, data).then((r) => r.data);
export const adminInsights = () =>
  axios.get(`${API}/admin/insights`, authHeaders()).then((r) => r.data);
export const adminReferrals = () =>
  axios.get(`${API}/admin/referrals`, authHeaders()).then((r) => r.data.referrals);
export const adminUpdateReferral = (id, reward_status) =>
  axios.patch(`${API}/admin/referrals/${id}`, { reward_status }, authHeaders()).then((r) => r.data);

export const adminRentals = () =>
  axios.get(`${API}/admin/rentals`, authHeaders()).then((r) => r.data.bookings);
export const downloadStockSheet = async () => {
  const res = await axios.get(`${API}/admin/stock-sheet.pdf`, { ...authHeaders(), responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = "CompCar-Stock-Sheet.pdf";
  a.click();
  URL.revokeObjectURL(url);
};
